<script lang="ts">
	export let value: string,
		x: number,
		y: number,
		fontSize: number = null,
		type: 'title' | 'value' = 'value';

	const getFontSize = () => {
		const len = value.replace(/\./g, '').length;
		if (len > 6) {
			return 10;
		}
		if (len > 4) {
			return 12;
		}
		return 14;
	};

	fontSize = fontSize || getFontSize();
</script>

<text {x} {y} class={type} dominant-baseline="middle" text-anchor="middle" font-size="{fontSize}px"
	>{value}</text
>

<style>
	text.title {
		font-style: italic;
		text-transform: capitalize;
	}
</style>
